import React from "react";
import "react-toastify/dist/ReactToastify.css";
import UserTable from "@components/Tables/UserTable";
import { TitleWithDivider } from "@common/TitleWithDivider";
import { SearchBar } from "@components/SearchBar/SearchBarTemplate";
import { HeaderItems } from "@common/HeaderItems";
import LoadingIcon from "@common/LoadingIcon";
import WarningModal from "@components/Modals/WarningModal";
import FilterModal from "@components/Modals/FilterSelectModal";
import PaginationControls from "@services/PaginationControls";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import { UseUserMainPage } from "@pages/User/UserMainPage/hooks/UseUserMainPage";

const UserMainPage: React.FC = () => {
  const form = UseUserMainPage();

  return (
    <>
      <div>
        <TitleWithDivider titleText={pageHeaders.USER.main} useDivider={true} />
        <SearchBar
          onSearch={form.onSearch}
          onFilterSearch={form.onFilteredSearch}
          searchBarText={"社内電話帳検索キーワード"}
          buttonLeft={"検索"}
          buttonRight={"絞込検索"}
          setSearchTerm={form.setSearchTerm}
          disabled={form.loading}
        ></SearchBar>
        <HeaderItems
          items={form.headerItems}
          topPadding={5}
          disabled={form.loading}
        ></HeaderItems>
        {form.loadingAllUsers && (
          <div className="fixed inset-0 flex items-center justify-center backdrop-brightness-50 z-50">
            <div className="bg-white bg-opacity-95 p-5 rounded-lg shadow-lg flex items-center justify-center">
              <LoadingIcon bodyText={messages.user.loading} />
            </div>
          </div>
        )}
        <div className="mb-5"></div>
        {form.loading ? (
          <div className="flex items-center justify-center h-40 rounded-xl">
            <LoadingIcon />
          </div>
        ) : (
          <>
            <UserTable
              onUserSelect={form.handleUserSelect}
              onDeselectAll={form.handleDeselectAll}
              userInformation={form.userData}
              allSelected={form.allSelected}
              setAllSelected={form.setAllSelected}
            />
            <PaginationControls
              currentPage={form.currentPage}
              totalPages={form.totalPages}
              totalItems={form.totalUsers}
              displayedItem={"社内電話帳"}
              onPageChange={form.handlePageChange}
              setPerPage={form.setItemsPerPage}
              perPage={form.itemsPerPage}
            />
          </>
        )}
        <WarningModal
          title={form.warningModalTitle}
          body={form.warningModalBody}
          confirmText={form.warningModalConfirm}
          isOpen={form.deleteModalOpen}
          onConfirm={form.deleteUserData}
          onRequestClose={form.closeDeleteModal}
        ></WarningModal>
        <FilterModal
          isOpen={form.filterModalOpen}
          onRequestClose={form.onFilteredModalClose}
          onApplyFilters={form.doFilteredSearch}
          filters={form.filters}
        ></FilterModal>
      </div>
    </>
  );
};

export default UserMainPage;
